// External Imports
import React from "react";

// Defines the main pages routes
import NotFoundPage from "./not-found-page/NotFoundPage";
import ViewUsersPage from "./viewUsersPage/ViewUsersPage";
import InstitutionsTable from "./viewInstitutionsPage/components/InstitutionsTable";
import InstitutionOverview from "./viewInstitutionsPage/components/InstitutionOverview";
import ViewDepartmentsTable from "./viewDepartmentsPage/ViewDepartmentsTable";
import { getAllInstitutions } from "../core/ServerApiLayer/VOne/institutions/get_all_instititions";
import { getAllDepartments } from "../core/ServerApiLayer/VOne/institutions/get_departments";
import { getAllUsers } from "../core/ServerApiLayer/VOne/institutions/get_users";
import { assignLicense } from "../core/ServerApiLayer/VOne/licenses/assign";
import { unassignLicense } from "../core/ServerApiLayer/VOne/licenses/unassign";
import { getLicenses } from "../core/ServerApiLayer/VOne/institutions/get_available_licenses";
import { passwordResetRequest } from "../core/ServerApiLayer/VOne/users/request_password";
import { createInstitution } from "../core/ServerApiLayer/VOne/institutions/create";
import { createDepartment } from "../core/ServerApiLayer/VOne/institutions/create_department";

// Session guard applied to every route in this table
import { protectRoutes } from "../components/auth/protectRoutes";

// The admin surface is a nested resource hierarchy so that every "Back" is just
// one level up the URL, and each page carries the ids its parents need:
//
//   /institutions
//   /institution/:institutionId                                (overview)
//   /institution/:institutionId/departments
//   /institution/:institutionId/department/:departmentId       (department users)
//   /institution/:institutionId/users                          (all institution users)
//
// A department admin who logs in without an institution context lands on the
// flat /department/:departmentId/users fallback instead.
//
// Every page here reads institution or user records, so the whole table is
// guarded.
export const MainPageRoutes = protectRoutes([
    {
        path: "/institutions",
        element: (
            <InstitutionsTable
                getAllInstitutions={getAllInstitutions}
                createInstitution={createInstitution}
            />
        ),
    },
    {
        path: "/institution/:institutionId",
        element: (
            <InstitutionOverview getAllInstitutions={getAllInstitutions} />
        ),
    },
    {
        path: "/institution/:institutionId/departments",
        element: (
            <ViewDepartmentsTable
                getAllDepartments={getAllDepartments}
                createDepartment={createDepartment}
            />
        ),
    },
    {
        path: "/institution/:institutionId/department/:departmentId",
        element: (
            <ViewUsersPage
                getAllUsers={getAllUsers}
                assignLicense={assignLicense}
                unassignLicense={unassignLicense}
                getLicenses={getLicenses}
                requestPassword={passwordResetRequest}
            />
        ),
    },
    {
        path: "/institution/:institutionId/users",
        element: (
            <ViewUsersPage
                getAllUsers={getAllUsers}
                assignLicense={assignLicense}
                unassignLicense={unassignLicense}
                getLicenses={getLicenses}
                requestPassword={passwordResetRequest}
            />
        ),
    },
    {
        // Fallback for a department admin who arrives without an institution
        // context (only their department id): back returns to the landing page.
        path: "/department/:departmentId/users",
        element: (
            <ViewUsersPage
                getAllUsers={getAllUsers}
                assignLicense={assignLicense}
                unassignLicense={unassignLicense}
                getLicenses={getLicenses}
                requestPassword={passwordResetRequest}
            />
        ),
    },
    {
        path: "/user",
        element: <NotFoundPage />,
    },
]);
